module.exports = __webpack_public_path__ + "img/chat.3dc36dd8.png";